import { Api } from '@/infrastructure';
import { useState } from 'react';

type UseRecreationPriceResult = {
  isSending: boolean;
  consultRecreationPrice: (recreationId: number) => Promise<void>;
};

export const useRecreationPrice = (): UseRecreationPriceResult => {
  const [isSending, setIsSending] = useState<boolean>(false);

  const consultRecreationPrice = async (
    recreationId: number
  ): Promise<void> => {
    setIsSending(true);
    try {
      await Api.post(`recreations/${recreationId}/consult`, 'customer', {
        recreation_id: recreationId,
      });
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      setIsSending(false);
    }
  };

  return { isSending, consultRecreationPrice };
};
